export class FileHelper {
  public static downloadBlobFile = (blob: Blob, fileName: string) => {
    const fileUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', fileName);

    document.body.appendChild(link);

    link.click();

    link.parentNode?.removeChild(link);
  };

  /**
   * Returns notification id based on provided file name
   *
   * @param fileName - The name of the file processed
   * @returns Notification ID generated using file name
   *
   */
  public static getFileNotificationId = (fileName: string): string => {
    return `upload_${fileName.replace(/[^a-zA-Z0-9]/g, '_')}`;
  };
}
